import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const getCurrentDateWithTimezone = (): string => {
  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const now = dayjs().tz(localTimezone);
  const offset = now.format('Z');

  return now.format('YYYY-MM-DDTHH:mm:ss.SSS') + offset;
};

export const getCurrentTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
